/**
 * Calls to action. Conversion rule: every high-intent CTA goes to ONE lead-capture experience (/demo).
 * The sales calendar is always the SECOND step, shown only after the lead is captured.
 */
import { routeHref } from '../lib/links';
import { ARROW_ICON, icon } from './icons';

export const INTENT_HREF = {
  demo: routeHref('/demo'),
  'enterprise-contact': routeHref('/demo?intent=enterprise-contact'),
  sales: routeHref('/demo?intent=sales'),
} as const;

export const demoAttrs = (cta = 'book_enterprise_demo'): string => `href="${INTENT_HREF.demo}" data-cta="${cta}"`;

export const btnDemo = (
  label = 'Book an Enterprise Demo',
  className = 'btn-primary',
  cta = 'book_enterprise_demo',
): string => `<a class="btn ${className}" ${demoAttrs(cta)}>${label} ${ARROW_ICON}</a>`;

export const btnSales = (className = 'btn-ghost'): string =>
  `<a class="btn ${className}" href="${INTENT_HREF.sales}" data-cta="talk_to_sales">Talk to Sales</a>`;

export const btnTeam = (className = 'btn-ghost', label = 'Contact Our Enterprise Team'): string =>
  `<a class="btn ${className}" href="${INTENT_HREF['enterprise-contact']}" data-cta="contact_enterprise_team">${label} ${ARROW_ICON}</a>`;

export const salesLink = (label = 'Talk to Sales'): string =>
  `<a class="tlink" href="${INTENT_HREF.sales}" data-cta="talk_to_sales">${label} ${icon('arrow')}</a>`;

export const tlink = (label: string, to: string, attrs = ''): string =>
  `<a class="tlink" href="${to}" ${attrs}>${label} ${icon('arrow')}</a>`;
